import { isElement } from "./isElement";
import * as CoreUtils from "./helpers";

var Selector = function(obj, parentNode = document){
	if(typeof obj == "string"){
		return Selector.resolve_string_to_object(obj,parentNode);
	}else if(isElement(obj)){
		return obj;
	}else{
		return {};
	}
};
Selector.prototype = Selector.__proto__ = {};
Selector.resolve_string_to_object = (string,parentNode) =>{
	
};
export {Selector};